import { __awaiter } from "tslib";
import { ApsDerivationRequestService } from "@/servicesTs/models/interconsult/apsDerivationRequest";
const moduleTableApsDerivationRequest = {
    namespaced: true,
    state: {
        aps_derivation_request: [],
        filters: {
            list: null,
            request_date_start: null,
            request_date_end: null,
            priority: null,
            service_node_id: null,
            unity_node_id: null,
            ges: null,
            destination_node_id: null,
            origin_node_id: null,
            patient_id: null,
            patient_name: null,
            patient_apepat: null,
            patient_apemat: null,
            schedule_citation_origin_id: null,
            page: 1,
        },
        loading: false,
    },
    getters: {
        getApsDerivationRequest(state) {
            return state.aps_derivation_request;
        },
        getFilters(state) {
            return state.filters;
        },
        getLoading(state) {
            return state.loading;
        },
    },
    mutations: {
        setApsDerivationRequest(state, aps_derivation_request) {
            state.aps_derivation_request = aps_derivation_request;
        },
        setFilter(state, filters) {
            state.filters = Object.assign(Object.assign({}, state.filters), filters);
            console.log("filters", state.filters);
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        resetFilters(state, payload) {
            state.filters = Object.assign(Object.assign({}, state.filters), payload);
        },
    },
    actions: {
        getApsDerivationRequest({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const APS_DERIVATION_REQUEST = yield ApsDerivationRequestService.filterManagement(state.filters);
                commit("setApsDerivationRequest", APS_DERIVATION_REQUEST);
                commit("setLoading", false);
            });
        },
        onPageChange({ commit, dispatch }, page) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setFilter", { page });
                yield dispatch("getApsDerivationRequest");
            });
        },
        clearFilter({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                commit("resetFilters", {
                    list: null,
                    request_date_start: null,
                    request_date_end: null,
                    priority: null,
                    service_node_id: null,
                    unity_node_id: null,
                    ges: null,
                    diagnostic: null,
                    // destination_node_id: null,
                    origin_node_id: null,
                    patient_id: null,
                    schedule_citation_origin_id: null,
                    page: 1,
                });
                console.log("state", state);
                commit("setApsDerivationRequest", {});
                commit("setLoading", false);
            });
        },
    },
};
export default moduleTableApsDerivationRequest;
